export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = "ApiError";
  }
}

export async function registerEmail(emailAddress: string, recaptchaToken?: string): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/plus/registeremail`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: emailAddress.trim(), recaptchaToken }),
  });

  if (!res.ok) {
    let msg = `Failed to register email (status ${res.status})`;
    try {
      const data = await res.json();
      if (data?.message) msg = data.message;
    } catch {}
    throw new Error(msg);
  }
}

type PresignedUpload = {
  key: string;
  putUrl: string;
  name: string;
  type: string;
  size: number;
};
export async function submitSupportTicket(
  data: any,
  recaptchaToken?: string,
  files?: File[]
): Promise<{ ticketId: string; createdAt: string; uploads: PresignedUpload[] }> {
  const res = await fetch(`${API_BASE_URL}/contact/support`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...data,
      recaptchaToken,
      files: (files ?? []).map((f) => ({ name: f.name, type: f.type, size: f.size })),
    }),
  });

  const body = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(body?.message || "Failed to submit support ticket, please try again later.");
  }

  return {
    ticketId: body.ticketId,
    createdAt: body.createdAt,
    uploads: Array.isArray(body.uploads) ? body.uploads : [],
  };
}

export async function uploadAttachments(
  ticketId: string,
  createdAt: string,
  attachments: { key: string; name: string; type: string; size: number }[]
): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/contact/support/attachments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ticketId, createdAt, attachments }),
  });

  if (!res.ok) throw new Error("Failed to save attachments.");
}